import { styled } from '@mui/material';

import { isBefore } from 'date-fns';

import {
  PaymentPlansContext,
  SubscriptionDetails,
  PlanOptions,
} from '@app-velocity/modules/payments';

import { CenteredLoader, Modal } from '@app-velocity/ui';

import { useCurrentUser } from '@app-velocity/libs/auth';

import { useOwnedTeamSubscriptionInfo } from '@app-velocity/libs/teams-data-access';

const PlansContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'center',
}));

export const Subscription = () => {
  const currentUser = useCurrentUser();
  const { loading, subInfo, tier } = useOwnedTeamSubscriptionInfo();
  if (!currentUser || loading) return <CenteredLoader />;

  if (!subInfo) return null;

  const { currentPeriodEnd, willAutoRenew } = subInfo;
  if (!tier) return null;

  return (
    <>
      <Modal.Header title="payments:options" />
      <Modal.Content>
        <PaymentPlansContext.Provider
          value={{
            mainPath: '/',
            subscribedUntil: currentPeriodEnd
              ? new Date(currentPeriodEnd)
              : null,
            autoRenew: willAutoRenew || false,
            subscribed:
              !!currentPeriodEnd &&
              isBefore(new Date(), new Date(currentPeriodEnd)),
            tier,
          }}
        >
          <SubscriptionDetails />
          <PlansContainer>
            <PlanOptions />
          </PlansContainer>
        </PaymentPlansContext.Provider>
      </Modal.Content>
    </>
  );
};
